import LegalPage from "./LegalPage";

const SECCIONES = [
    {
        titulo: "Responsable del tratamiento",
        texto: "BIZecomacademy (en adelante, «nosotros») es responsable del tratamiento de los datos personales que nos proporcionas a través de este sitio web. Si tienes preguntas sobre esta política, puedes contactarnos a través del formulario de agendamiento de este mismo sitio.",
    },
    {
        titulo: "Datos que recopilamos",
        texto: "Cuando agendas una consultoría o interactúas con nuestros formularios, recopilamos los datos que tú mismo nos facilitas: nombre, correo electrónico, número de teléfono y la información que decidas compartir sobre tu situación. Además, como la mayoría de los sitios web, se pueden recopilar datos técnicos de navegación (tipo de dispositivo, navegador, páginas visitadas) mediante cookies y tecnologías similares.",
    },
    {
        titulo: "Para qué usamos tus datos",
        texto: "Usamos tus datos únicamente para: gestionar y confirmar tu consultoría gratuita, contactarte en relación con nuestra consultoría o programa, responder a tus solicitudes, mejorar el contenido del sitio y, si lo autorizas, enviarte comunicaciones sobre nuestros programas. No vendemos ni alquilamos tus datos personales a terceros.",
    },
    {
        titulo: "Servicios de terceros",
        texto: "Este sitio utiliza servicios de terceros que pueden tratar datos según sus propias políticas de privacidad: el sistema de agendamiento de consultorías y Google Meet (para la reserva y realización de la videollamada), Vimeo y YouTube (para la reproducción de videos) y, eventualmente, herramientas de medición publicitaria como el Pixel de Meta. Te recomendamos revisar las políticas de privacidad de cada proveedor.",
    },
    {
        titulo: "Cookies",
        texto: "Podemos usar cookies propias y de terceros para el funcionamiento del sitio, recordar tus preferencias y medir el rendimiento de nuestro contenido. Puedes configurar tu navegador para rechazar o eliminar las cookies; ten en cuenta que algunas funciones del sitio podrían dejar de funcionar correctamente.",
    },
    {
        titulo: "Conservación y seguridad",
        texto: "Conservamos tus datos solo durante el tiempo necesario para los fines descritos o mientras exista una relación activa contigo. Aplicamos medidas razonables de seguridad para proteger tu información frente a accesos no autorizados, aunque ningún sistema en internet es 100% infalible.",
    },
    {
        titulo: "Tus derechos",
        texto: "Puedes solicitar en cualquier momento el acceso, la rectificación, la cancelación o la oposición al tratamiento de tus datos personales, así como retirar tu consentimiento para recibir comunicaciones. Para ejercer estos derechos, contáctanos a través del formulario de agendamiento de este sitio.",
    },
    {
        titulo: "Cambios a esta política",
        texto: "Podemos actualizar esta Política de Privacidad ocasionalmente. La versión vigente será siempre la publicada en esta página, con su fecha de última actualización. Te recomendamos revisarla periódicamente.",
    },
];

export default function Privacidad() {
    return <LegalPage titulo="Política de Privacidad" secciones={SECCIONES} />;
}
